import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from 'react-oidc-context';

import { Helmet } from 'react-helmet-async';
import Grid from '@mui/material/Grid2';

import { 
  Campaign,
  Character 
} from "@dndModels";
import { DATA_TYPE_INFO } from "@dndModels/Constants";

import API from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
// import DataUtilities from '../../utilities/common_utilities';

import CharacterSheet from "@dndComponents/character/CharacterSheet";
import LoadingBox from "@components/input/LoadingBox";
import CharacterSaveTools from "@dndComponents/character/misc/CharacterSaveTools";

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
// const common_util = DataUtilities.getInstance();

interface Props { 
  id: string;
  char?: Character;
  campaign?: Campaign;
  shared?: boolean;
}

export default function CharacterSheetParent({ id, char: param_char, campaign, shared }: Props) {
  const [loading, setLoading] = useState(false);
  const [loading_message, setLoadingMessage] = useState("");
  const [percentage, setPercentage] = useState(0);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  // const [last_reload, setLastReload] = useState(0);
  const [logging_in, setLoggingIn] = useState(false);
  const [char, setChar] = useState<Character>(new Character());
  const [name_for_helmet, setNameForHelmet] = useState(char.name);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  // Loads the editing Character into state
  const loadObject = useCallback(async (id: string) => {
    const onProgress = (data_type: string, percent: number ) => {
      const dt_info = DATA_TYPE_INFO.find(o => o.data_type === data_type);
      // console.log(dt_info);
      // console.log(percentage);
      // debugger;
      if (dt_info) {
        setLoadingMessage(`Loading ${dt_info.plural}`);
      } else if (data_type === "Processing") {
        setLoadingMessage("Processing");
      } else {
        setLoadingMessage(`Loading ${data_type}`);
      }
      setPercentage(percent * 100);
    };
    const onError = (message: string) => {
      setLoadingMessage(message);
    };
    let res = await char_util.getCharacter({ id, campaign, onProgress, onError });
    if (res) {
      if (param_char) {
        param_char.copy(res);
        param_char.subscription_holder.recalculate();
        res = param_char;
      }
      setChar(res);
      setNameForHelmet(res.name);
    }
    setLoading(false);
  }, [id]);

  const load = useCallback( async () => {
    // debugger;
    console.log("load()");
    if ((id && id !== "") || (param_char && param_char._id !== id)) {
      const onProgress = (data_type: string, percent: number ) => {
        const dt_info = DATA_TYPE_INFO.find(o => o.data_type === data_type);
        // console.log(dt_info);
        // console.log(percentage);
        // debugger;
        if (dt_info) {
          setLoadingMessage(`Loading ${dt_info.plural}`);
        } else if (data_type === "Processing") {
          setLoadingMessage("Processing");
        } else {
          setLoadingMessage(`Loading ${data_type}`);
        }
        setPercentage(percent * 100);
      };
      const onError = (message: string) => {
        setLoadingMessage(message);
      };
      if (param_char && param_char.connected) {
        setChar(param_char);
      } else {
        if (param_char) {
          id = param_char._id;
        }
        // console.log("Loading");
        let res = await char_util.getCharacter({ id, campaign, onProgress, onError });
        if (res) {
          if (param_char) {
            param_char.copy(res);
            param_char.subscription_holder.recalculate();
            res = param_char;
          }
          setChar(res);
          setNameForHelmet(res.name);
          res.subscription_holder.subscribe("Reload", mounted, onReload);
        }
      }
    } 
    setLoading(false);
    setLoggingIn(false);
  }, [id, param_char, loadObject]);
  
  useEffect(() => {
    if (!fetched && api.user) {
      setFetched(true);
      setLoading(true);
      setTimeout(() => {
        load();
      }, 1000);
    }
  });
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const onReload = () => {
    // debugger;
    if (id && id !== "" && char._id !== id) {
      setLoading(true);
      // console.log("126");
      loadObject(id);
    } 
  }

  console.log(api.user);
  console.log(char);
  if (logging_in) {
    return (
      <div className="centered">
        <LoadingBox message="Logging in" size={window.innerHeight * 0.5} height={window.innerHeight - 100} />
      </div>
    );
  } else if (api.user === null) {
    return (
      <div className="centered" style={{ height: "100%" }}>
        You must be logged in to view characters.
      </div>
    );
  } else if (!fetched || loading) {
    console.log(loading_message);
    return (
      <div className="centered">
        <LoadingBox message={loading_message} percentage={percentage} size={window.innerHeight * 0.5} height={window.innerHeight - 100} />
      </div>
    );
  } else if (api.user._id !== char.owner_id && 
    (!char.campaign || 
      (char.campaign.owner_id !== api.user._id && 
        !char.campaign.player_ids.includes(api.user._id)))) {
    console.log(api.user);
    console.log(char);
    return (
      <div>
        This is not your character.
      </div>
    );
  } else { 
    return (
      <Grid container spacing={0} direction="row">
        <Helmet>
          <title>Homebrew Labs - { `Character Sheet: ${name_for_helmet}` }</title>
        </Helmet>
        <Grid size={12}>
          <CharacterSaveTools
            char={char}
          />
        </Grid>
        <Grid size={12}>
          { !reloading && 
            <CharacterSheet
              char={char}
              shared={shared}
            />
          }
        </Grid>
      </Grid>
    ); 
  }
}
